import { clog } from '@/utils/clog';
import { EventHandlerClass } from '@/utils/events';
import { useEffect } from 'react';

const eventHandler = new EventHandlerClass(window);

/*
p2d = parent to digor
d2p = digor to parent

sending: d2p:digor:ready, d2p:digor:link-click
getting: p2d:digor:clear
*/

export const useBridgeMessages = ({
  onMessageFromParent,
  onMessageFromIframe,
  iframe,
}: {
  onMessageFromParent?: (message: any) => void;
  onMessageFromIframe?: (message: any) => void;
  iframe?: HTMLIFrameElement | null;
} = {}) => {
  useEffect(() => {
    eventHandler.addEventListener('message.digor', (event: any) => {
      if (event?.data?.type?.includes('p2d:digor:')) {
        clog('digor-message-from-parent:', event.data);
        onMessageFromParent?.(event.data);
      }
      if (event?.data?.type?.includes('d2p:digor:')) {
        clog('digor-message-from-iframe:', event.data);
        onMessageFromIframe?.(event.data);
      }
    });

    return () => {
      eventHandler.removeEventListener('message.digor');
    };
  }, []);

  return {
    sendMessageToParent: (message: string, moreData?: object) => {
      clog('digor-message-to-parent:', message, moreData);
      window.parent.postMessage({ type: message, ...moreData }, '*');
    },
    sendMessageToIframe: (message: string, moreData?: object) => {
      let theIframe = iframe;

      if (!iframe) {
        theIframe = document.getElementById(
          'digor-iframe'
        ) as HTMLIFrameElement;
      }

      clog('digor-message-to-iframe:', theIframe, message, moreData);

      theIframe?.contentWindow?.postMessage(
        { type: message, ...moreData },
        '*'
      );
    },
  };
};
